import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.community');
import { OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-community',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.community/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageCommunityComponent implements OnInit, OnDestroy {

  public category: string = 'notice';
  public action: string = 'list';
  public postId: string = '';
  public parentId: string = '';
  public role: string | null = null;
  public ready = false;
  private routerSub: Subscription | null = null;

  constructor(@Inject( Service)     public service: Service,@Inject( Router  )     private router: Router  ) {}

  public async ngOnInit() {
    await this.service.init();
    const allowed = await this.service.auth.allow(true, "/auth/login");
    if (!allowed) return;

    const authSession: any = this.service.auth?.session ?? {};
    this.role = (authSession.role ?? '').toString().toLowerCase() || null;

    this.applyRoute();
    this.ready = true;
    await this.service.render();

    this.routerSub = this.router.events.subscribe(async (event) => {
      if (event instanceof NavigationEnd) {
        this.applyRoute();
        await this.service.render();
      }
    });
  }

  ngOnDestroy() {
    if (this.routerSub) this.routerSub.unsubscribe();
  }

  private applyRoute() {
    const nextCategory = WizRoute?.segment?.category || 'notice';
    const nextAction = WizRoute?.segment?.action || 'list';
    const nextPostId = WizRoute?.segment?.post_id || '';
    const nextParentId = WizRoute?.segment?.parent_id || '';

    this.category = nextCategory;
    this.action = nextAction;
    this.postId = nextPostId;
    this.parentId = nextParentId;
  }
}

export default PageCommunityComponent;